module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/vegamagic.55b1361.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/vegamagic.jpg
// module id = IIgT
// module chunks = 0